import { isAfter, parse, parseISO } from 'date-fns';

export function isDateGreaterThan(
  inputDate: string | undefined = new Date().toISOString(),
  compareDate: string | undefined = new Date().toISOString()
): boolean {
  const parsedInputDate = inputDate.includes('T')
    ? parseISO(inputDate)
    : parse(inputDate, 'yyyy-MM-dd HH:mm:ss', new Date());

  const parsedCompareDate = compareDate.includes('T')
    ? parseISO(compareDate)
    : parse(compareDate, 'yyyy-MM-dd HH:mm:ss', new Date());

  return isAfter(parsedInputDate, parsedCompareDate);
}
